export const posthogProd = 'phc_6iSnqhLXoUrIssc5cfgjf9YrF5voKG18RK9Sk9bKuSM'
export const posthogDev = 'phc_JO6OBNTSVv4G3rLGXMysmHxsEAOTaHXjFExlP5hMsgs'
export const urlPosthogProd = 'https://posthog.tools.justo.ninja'
export const urlPosthogDev = 'https://posthog.sandbox.justo.ninja'
